// src/App.js
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./utils/ProtectedRoute";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
// 로그인 및 회원가입 페이지
import Login from "./pages/Login";
import Signup from "./pages/Signup";
// 게임 페이지
import GamePage from "./pages/GamePage";
import GameDetailPage from "./pages/GameDetailPage";
// 이벤트 페이지
import EventPage from "./pages/EventPage";
import EventDetailPage from "./pages/EventDetailPage";
// 어드민 페이지
import AdminDashboard from "./pages/admin/AdminDashboard";
import BannerCreatePage from "./pages/admin/BannerCreatePage";
import BannerEditPage from "./pages/admin/BannerEditPage";
import GameCreatePage from "./pages/admin/GameCreatePage";
import GameEditBanner from "./pages/admin/GameEditBanner";
import GameEditPage from "./pages/admin/GameEditPage";
import EventCreatePage from "./pages/admin/EventCreatePage";
import EventEditBanner from "./pages/admin/EventEditBanner";
import EventEditPage from "./pages/admin/EventEditPage";
import GameJamCreatePage from "./pages/admin/GameJamCreatePage";
// 게임잼 페이지
import GameJamPage from "./components/gamejam/GameJamGrid";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./utils/AuthContext";
import ScrollToTop from "./components/ScrollToTop";

const queryClient = new QueryClient();

function LayoutWrapper({ children }) {
  const location = useLocation();
  const isFullScreenPage = ["/login", "/signup"].includes(location.pathname);

  if (isFullScreenPage) {
    return <>{children}</>;
  }

  return (
    <div className="bg-[#121212] text-white min-h-screen">
      <div className="sticky top-0 z-50">
        <Header />
      </div>
      <main>{children}</main>
      <Footer />
    </div>
  );
}

function AppRoutes() {
  return (
    <LayoutWrapper>
      <Routes>
        {/* 홈 */}
        <Route path="/" element={<Home />} />

        {/* 로그인 및 회원가입 */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />

        {/* 관리자 전용 영역 */}
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute adminOnly>
              <Outlet />
            </ProtectedRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="banner/create" element={<BannerCreatePage />} />
          <Route path="banner/edit/:bannerId" element={<BannerEditPage />} />
          <Route path="game/create" element={<GameCreatePage />} />
          <Route path="game/edit/banner/:gameId" element={<GameEditBanner />} />
          <Route path="game/edit/detail/:gameId" element={<GameEditPage />} />
          <Route path="event/create" element={<EventCreatePage />} />
          <Route path="event/edit/banner/:eventId" element={<EventEditBanner />} />
          <Route path="event/edit/detail/:eventId" element={<EventEditPage />} />
          <Route path="gamejam/create" element={<GameJamCreatePage />} />
        </Route>

        {/* 일반 사용자용 페이지 */}
        <Route path="/games" element={<GamePage />} />
        <Route path="/games/detail/:gameId" element={<GameDetailPage />} />
        <Route path="/events" element={<EventPage />} />
        <Route path="/events/detail/:eventId" element={<EventDetailPage />} />
        <Route path="/gamejam" element={<GameJamPage />}></Route>
      </Routes>
    </LayoutWrapper>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
          {/* 경로(path)가 바뀔 때마다 스크롤을 맨 위로 올립니다 */}
          <ScrollToTop />
          <AppRoutes />
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  );
}
